module.exports = __webpack_public_path__ + "static/paragraph-3-07bb98f3f475d9418bc556b8500c6982.svg";